import { Typography } from "e100-react-components";
import React from "react";

interface CarLicenseProps {
  licensePlate: Nullable<string>;
}

export const CarLicense = ({ licensePlate }: CarLicenseProps) => {
  return (
    <Typography variant="subtitle2" color="textPrimary">
      {licensePlate} • E100Mobile
    </Typography>
  );
};
